/**
 * Lightweight analytics hook. Pushes to window.dataLayer (GTM-compatible)
 * when present; silently no-ops otherwise. Wire a real endpoint later
 * without touching feature code.
 */
export function trackEvent(event, props = {}) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...props });
  } catch {
    /* SSR / blocked storage — ignore */
  }
}
